import styled from 'styled-components';

const LoaderItem = styled.div`
  width: 100%;
  height: 19px;
  margin: 10.5px 0;
  background: #F7F7F7;
  border-radius: 2px;
  padding-left: 16px;
  padding-right: 16px;
`;

const LoaderContainer = styled.div`
  width: 100%;
  padding: 0 16px;
`;

const Loader = () => (
  <LoaderContainer>
    <LoaderItem />
    <LoaderItem />
    <LoaderItem />
    <LoaderItem />
    <LoaderItem />
    <LoaderItem />
    <LoaderItem />
  </LoaderContainer>
);

export default Loader;
